<template>
  <div
    class="
      absolute
      top-0
      w-screen
      h-screen
      bg-dark
      text-white
      center-all-column
    "
  >
    <img src="@/assets/images/logo-white.svg" class="my-4" />
    <font-awesome-icon :icon="['fa', 'sun']" spin class="text-4xl" />
  </div>
</template>

<script>
export default {};
</script>

<style></style>
